import { PageContainer } from "../../components/PageComponents";
import { Summary, UserActivity, LeadershipBoard, Revenue } from "./components";

const Dashboard = () => {
  const summaryData = {
    users: 100,
    productPurchased: 100,
    coinsPurchased: 14,
    revenue: 500000,
  };

  return (
    <PageContainer title="Dashbpard">
      <Summary {...summaryData} />
      <div className="col-6">
        <div className="row-2">
          <UserActivity />
          <LeadershipBoard />
        </div>
        <Revenue />
      </div>
    </PageContainer>
  );
};

export default Dashboard;
